import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-modal-approve',
  templateUrl: './modal-approve.component.html',
  styleUrls: ['./modal-approve.component.css']
})
export class ModalApproveComponent  {

  constructor(public dialogRef: MatDialogRef<ModalApproveComponent>) { }

  closeModalAccept(){
    this.dialogRef.close(true);
  }

}
